import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import swal from 'sweetalert';
import { listSynthesisConfigurations } from '../../services/synthesisConfigService';
import { SynthesisConfigurationResponse } from '../../types/synthesisConfig';

const SynthesisConfigurationsList: React.FC = () => {
  const [configs, setConfigs] = useState<SynthesisConfigurationResponse[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  const fetchConfigs = async () => {
    setLoading(true);
    try {
      const data = await listSynthesisConfigurations();
      setConfigs(data);
    } catch (error) {
      console.error("Erro ao buscar configurações do Synthesis:", error);
      swal("Erro", "Não foi possível carregar as configurações.", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchConfigs();
  }, []);

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h5">Configurações do Publisol Synthesis</Typography>
      </Box>
      {loading ? (
        <Box sx={{ textAlign: 'center', mt: 3 }}>
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Nome da Entidade</TableCell>
                <TableCell>Endereço</TableCell>
                <TableCell>Criado em</TableCell>
                <TableCell>Atualizado em</TableCell>
                <TableCell>Ações</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {configs.map((cfg) => (
                <TableRow key={cfg.id} hover>
                  <TableCell>{cfg.id}</TableCell>
                  <TableCell>{cfg.entity_name}</TableCell>
                  <TableCell>{cfg.address.street}, {cfg.address.cep}</TableCell>
                  <TableCell>{new Date(cfg.created_at).toLocaleString()}</TableCell>
                  <TableCell>{new Date(cfg.updated_at).toLocaleString()}</TableCell>
                  <TableCell>
                    <Button variant="outlined" onClick={() => navigate(`/synthesis/configurations/${cfg.id}`)}>
                      Ver
                    </Button>
                    <Button variant="outlined" color="secondary" sx={{ ml: 1 }} onClick={() => navigate(`/synthesis/configurations/${cfg.id}/editar`)}>
                      Editar
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
              {configs.length === 0 && (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    Nenhuma configuração encontrada.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default SynthesisConfigurationsList;